import React from "react";
import STText from "../../../assets/styles/atoms/form/text.module.scss";

type Props = {
  className: string;
  name: string;
  defaultValue?: string;
  placeholder?: string;
  onChange: (value: string) => void;
};

const Number: React.FC<Props> = (props: Props) => {
  const hundleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange(e.target.value);
  };

  return (
    <input
      type="number"
      className={`${STText.text} ${props.className}`}
      aria-label={props.name}
      placeholder={props.placeholder}
      value={props.defaultValue}
      onChange={hundleChange}
    />
  );
};

export default Number;
